import { useState } from 'react';
import { Box } from '@mui/material';

const EquipmentImage = ({ src, alt }) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  if (hasError || !src) {
    return null;
  }

  return (
    <Box
      sx={{
        width: 120,
        height: 100,
        border: '1px solid #ddd',
        borderRadius: 1,
        backgroundColor: '#fff',
        padding: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <img 
        src={src} 
        alt={alt}
        onError={() => setHasError(true)}
        onLoad={() => setIsLoading(false)}
        style={{ 
          maxWidth: '100%', 
          maxHeight: '100%', 
          objectFit: 'contain',
          display: isLoading ? 'none' : 'block'
        }} 
      />
    </Box>
  );
};

export default EquipmentImage;
